declare namespace $ {

	export class $shm_hitalama_text_rows extends $mol_list {
		render_visible_only( ): boolean
	}
	
}

//# sourceMappingURL=rows.view.tree.d.ts.map